import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-accept-pending-modal',
    templateUrl: './accept-pending-modal.component.html',
    styleUrl: './accept-pending-modal.component.scss'
})
export class AcceptPendingModalComponent {

    constructor(private activeModal: NgbActiveModal) { }

    selected: 'ACCEPT_ALL' | 'SET_TO_MISSING' = 'ACCEPT_ALL' ;

    cancel() {
        this.activeModal.dismiss();
    }

    proceed() {
        this.activeModal.close(this.selected);
    }
}
